import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/new_phase';

/** 状況 `new_phase_other`（組み立ては `../fx/new_phase.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'new_phase_other', role: 'effect', ...spec }, 'new_phase_other_effect.js');
